import React, { FunctionComponent } from "react";
import { useFormikContext } from "formik";
import { useLingui } from "@lingui/react";
import { useWhiteLabelSetting } from "components/WhiteLabelProvider";
import { t } from "@lingui/macro";
import "./taxCalculationResult.css";
import { fetchResult } from "./taxCalculationApi";

export interface Props {}

export const TaxCalculationResult: FunctionComponent<Props> = () => {
  const { values } = useFormikContext<Record<string, string | number>>();
  const { i18n } = useLingui();
  const { locale } = i18n;
  const company = useWhiteLabelSetting("name") as string;
  const pensionLink = useWhiteLabelSetting("pensionLink") as string;
  const insuranceLink = useWhiteLabelSetting("insuranceLink") as string;
  const [result, setResult] = React.useState<string>();
  const [tips, setTips] = React.useState<string>("");
  const printDisclaimer = useWhiteLabelSetting("printDisclaimer");

  React.useEffect(() => {
    const doFetch = async () => {
      const [HTMLOverview, HTMLTips] = await fetchResult({ company, locale, values, pensionLink, insuranceLink });
      setResult(HTMLOverview);
      setTips(HTMLTips);
    };
    doFetch();
  }, [values, setResult, company, locale, setTips, pensionLink, insuranceLink]);

  if (!result) {
    return null;
  }

  return (
    <>
      <div className="nobanner" dangerouslySetInnerHTML={{ __html: tips }}></div>
      <div className="main">
        <div id="page_result">
          <div id="sofisk_output" dangerouslySetInnerHTML={{ __html: result }}></div>
          <div className="printdisclaimer">{printDisclaimer}</div>
          <div className="knoppen" style={{ textAlign: "right" }}>
            <button className="btn btn-default btn-print" onClick={window.print} title={i18n._(t`Afdrukken`)}>
              <i className="fa fa-print fa-2x"></i>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

TaxCalculationResult.displayName = "TaxCalculationResult";
